module.exports = __webpack_public_path__ + "static/media/11 Minutes of CFB Meeting held on 22.08.2023.88561829.pdf";